export const DropDownDataAnyaltics = {
  NDVI: "Crop Health",
  LAI: "Crop Growth",
  NDWI: "Moisture Stress",
  SM: "Soil Moisture",
};
